<template lang='pug'>
//- 會員登入區塊
div(:class='$style[`cc-popbox-forgetPassword`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 輸入
        span.font-normal-theme 帳號
        span.no-wrap 重設密碼
      div(:class='$style[`cc-content-title-tips`]') 請輸入有效的帳號，若為手機號碼，務必已完成信箱設定。若有其他問題請聯繫客服(service@cancell.ai)

    Inputer(
      title='手機 / 信箱的帳號'
      v-model.trim='formConfig.status.accountValue'
      :defaultValue='loginStatus ? loginProfile.oauth : ``'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`手機 / 信箱的帳號`'
      :beforeIcon='`mail`'
      :beforeIconSize='24'
      :beforeIconColor='`#d0d0d0`'
      :type='`email`'
      :errorRegex='formConfig.verify.accountRegexError'
      :errorRegexInfo='formConfig.verify.accountErrorLog'
      :errorValue='formConfig.verify.accountError'
      :keyPressEnter='handleCheckProgressBeforeLogin'
      @clearErrorMsg="(value) => {this.formConfig.verify.accountError = value[0]; this.formConfig.verify.accountRegexError = value[1]; this.showErrorMsg = false;}")

    button(
      title='送出'
      tabindex='0'
      aria-label='送出'
      :disabled='showLoading'
      :class='[$style[`cc-content-new-send`], $style[!this.formConfig.status.accountValue ? `cc-content-disabled` : ``]]'
      @click='handleCheckProgressBeforeLogin')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span {{ showLoading ? `` : `送出`}}

    div(v-if='showErrorMsg' :class='$style[`cc-content-error`]') {{ showErrorMsgText }}

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import Inputer from '../common/Input';
import IconLoading from '../../icon/Loading';

import {
  // putDjangoMemberFindPassword,
  postResetPasswordRequest,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    IconLoading,
  },

  data() {
    return {
      showLoading: false,
      formAccountType: '',

      formConfig: {
        status: {
          accountValue: '',
        },
        verify: {
          accountRegexError: false,
          accountErrorLog: '',
          accountError: false,
        },
        verifyAllPass: true,
      },
      showErrorMsg: false,
      showErrorMsgText: '',
    };
  },

  created() {
    this.showErrorMsg = this.$options.data().showErrorMsg;
    if (this.loginStatus) {
      this.formConfig.status.accountValue = this.loginProfile.oauth;
    }
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleFormsCheckToPass() {
      this.formConfig.verifyAllPass = this.$options.data().formConfig.verifyAllPass;
      const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      const phonePattern = new RegExp(/^09\d{8}$/);

      if (this.formConfig.status.accountValue) {
        // 信箱格式有誤
        if (this.formConfig.status.accountValue.match(emailPattern)) {
          this.formAccountType = 'email';
        } else if (this.formConfig.status.accountValue.match(phonePattern)) {
          this.formAccountType = 'phone';
        } else {
          this.formConfig.verify.accountRegexError = true;
          this.formConfig.verify.accountError = true;
          this.formConfig.verify.accountErrorLog = '格式錯誤(範例: 0912345678、mail@cancell.ai)';
          this.formConfig.verifyAllPass = false;
        }
      } else {
        // 信箱為空
        this.formConfig.verify.accountError = true;
        this.formConfig.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      if (!this.formConfig.verifyAllPass) { return; }
      this.showLoading = true;

      // 確認帳號 + 發信
      postResetPasswordRequest('', {
        oauth: this.formConfig.status.accountValue,
      })
        .then((res) => {
          if (res.data === 'success') {
            this.changePopBoxStatus({
              active: true,
              include: 'resetConfirm',
            });
            setTimeout(() => {
              this.handleClosePopBox();
            }, this.POP_DURATION);
          }
          this.showLoading = false;
        })
        .catch((err) => {
          // if (err.response.data === 'no-auth') {
          //   this.showErrorMsgText = '查無此手機或信箱帳戶';
          // } else if (err.response.data === 'need mail') {
          //   this.showErrorMsgText = '請先完成信箱設定';
          // } else {
          //   this.showErrorMsgText = '發生錯誤';
          // }
          this.showErrorMsgText = '發生錯誤';
          this.showErrorMsg = true;
          this.showLoading = false;
        });
    },

    async handleCheckProgressBeforeLogin() {
      await this.handleFormsCheckToPass();
      await this.handleConnectDjangoWithApi();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // authJwtToken: 'user/exportUserJwtToken',
      loginHashCode: 'user/exportUserHashCode',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popForgetPassword.scss';
</style>
